// import { i18n } from '@/plugins/i18n'
// import { apollo } from '@/plugins/apollo'
// graphql files

export default {
}
